import { Component, ojs, app, payload, state, v } from "modular-openscriptjs";
import {
	pageInfo,
	either,
	inform,
	scrollToTop,
	cleanDispose,
	processStart,
	processEnd,
} from "../../../helpers";
import { dom, tool } from "../../../fotastart";
import { PAGES, STRINGS, api } from "../../../declarations";

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class EditProfile extends Component {
	usernameAvailable = state(true);
	debounceTimer = null;
	deleteAccountModal = null;
	deleteAccountOtpInput = null;

	render(user, ...args) {
		if (route.is("user.edit-profile")) {
			pageInfo(PAGES.EDIT_PROFILE);
			scrollToTop();
		}

		return h.div(
			{ 
				class: "min-vh-100 py-4 pb-5 mb-5 mx-auto w-100 py-md-5",
				style: "max-width: 900px;"
			},
			h.div(
				{ class: "container px-3" },
				
				// Header
				h.div(
					{ class: "mb-4 d-flex align-items-center justify-content-between" },
					h.div(
						{ class: "d-flex align-items-center gap-3" },
						h.button(
							{
								class: "btn btn-white border shadow-sm circle p-2",
								onclick: "history.back()",
							},
							h.i({ class: "bi bi-arrow-left fs-5 text-secondary" })
						),
						h.h2({ class: "fw-bold mb-0 h4" }, "Edit Profile")
					),

					// Options dropdown (popover-styled)
					h.div(
						{ class: "dropdown" },
						h.button(
							{
								class: "btn btn-white border shadow-sm circle p-2",
								data_bs_toggle: "dropdown",
								aria_expanded: "false",
								title: "More options",
							},
							h.i({ class: "bi bi-three-dots-vertical fs-5 text-secondary" })
						),
						h.ul(
							{
								class: "dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-4 overflow-hidden py-2",
								style: "min-width: 200px;",
							},
							h.li(
								h.button(
									{
										class: "dropdown-item text-danger py-2 px-3 fw-medium d-flex align-items-center gap-2",
										onclick: this.method("confirmDeleteAccount"),
									},
									h.i({ class: "bi bi-trash3 fs-5" }),
									"Delete Account"
								)
							)
						)
					)
				),

				h.input({
					type: "hidden",
					name: "id",
					value: user.value?.id,
				}),

				// Responsive Flex Wrapper
				h.div(
					{ class: "d-flex flex-wrap gap-4 mb-4" },

					// Card 1: Identity & Username
					h.div(
						{
							class: "flex-fill",
							style: "background: #fff; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 24px rgba(0,0,0,0.03); padding: 24px; min-width: 320px; flex: 1 1 calc(50% - 12px);"
						},
						h.h5({ class: "fw-bold mb-3 text-dark d-flex align-items-center gap-2" }, 
							h.i({ class: "bi bi-person-badge text-primary" }),
							"Identity Details"
						),
						h.div(
							{ class: "d-grid gap-3" },
							
							// First Name
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-first-name" }, "First Name"),
								h.input({
									type: "text",
									name: "first-name",
									class: "form-control p-3 border shadow-none rounded-3",
									id: "profile-first-name",
									value: user.value?.first_name,
								})
							),

							// Last Name
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-last-name" }, "Last Name"),
								h.input({
									type: "text",
									name: "last-name",
									class: "form-control p-3 border shadow-none rounded-3",
									id: "profile-last-name",
									value: user.value?.last_name,
								})
							),

							// Display Name
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-display-name" }, "Display Name"),
								h.input({
									type: "text",
									name: "display-name",
									class: "form-control p-3 border shadow-none rounded-3",
									id: "profile-display-name",
									value: user.value?.display_name,
								}),
								h.div({ class: "form-text text-muted small mt-1" }, "This name will be visible to others")
							),

							// Username
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-username" }, "Username"),
								v(this.usernameAvailable, (available) => {
									return h.div(
										{ class: "input-group" },
										h.span({ class: "input-group-text bg-light border rounded-start-3 rounded-end-0" }, "@"),
										h.input({
											type: "text",
											name: "username",
											class: "form-control p-3 border shadow-none rounded-start-0 " + 
												(available.value === null ? "rounded-end-3" : "rounded-end-0"),
											id: "profile-username",
											value: user.value?.username,
											oninput: this.method("checkUsernameAvailability", [
												"${this}",
											]),
											listeners: {
												input: function () {
													this.value = this.value
														.toLowerCase()
														.replace(/[^a-z0-9._-]/g, "");
												},
											},
										}),
										available.value === true ? h.span(
											{
												class: "input-group-text bg-light border text-success rounded-end-3 rounded-start-0 p-3",
											},
											h.i({ class: "bi bi-check-circle-fill" })
										) : null,
										available.value === false ? h.span(
											{
												class: "input-group-text bg-light border text-danger rounded-end-3 rounded-start-0 p-3",
											},
											h.i({ class: "bi bi-x-circle-fill" })
										) : null,
										available.value === "processing" ? h.span(
											{
												class: "input-group-text bg-light border rounded-end-3 rounded-start-0 d-flex align-items-center justify-content-center p-3",
												style: "width: 40px;"
											},
											h.div({ class: "spinner-border spinner-border-sm text-primary", role: "status" })
										) : null
									);
								}),
								h.div({ class: "form-text text-muted small mt-1" }, "Your unique @username")
							)
						)
					),

					// Card 2: Contact & Demographics
					h.div(
						{
							class: "flex-fill",
							style: "background: #fff; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 24px rgba(0,0,0,0.03); padding: 24px; min-width: 320px; flex: 1 1 calc(50% - 12px);"
						},
						h.h5({ class: "fw-bold mb-3 text-dark d-flex align-items-center gap-2" }, 
							h.i({ class: "bi bi-telephone text-success" }),
							"Contact & About"
						),
						h.div(
							{ class: "d-grid gap-3" },
							
							// Phone Number
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-phone" }, "Phone Number"),
								h.div(
									{ class: "input-group" },
									h.select(
										{
											class: "form-select bg-light border rounded-start-3 rounded-end-0",
											style: "max-width: 90px",
											id: "profile-country-code",
										},
										h.option({ value: "+254" }, "+254")
									),
									h.input({
										type: "tel",
										name: "phone_number",
										class: "form-control p-3 border shadow-none rounded-end-3 rounded-start-0",
										id: "profile-phone",
										value: user.value?.phone?.substring((user.value?.phone?.length ?? 9) - 9) ?? "",
										placeholder: "7xxxxx...",
									})
								)
							),

							// Bio
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-bio" }, "Short Bio (optional)"),
								h.textarea(
									{
										class: "form-control p-3 border shadow-none rounded-3",
										rows: 2,
										id: "profile-bio",
										listeners: {
											input: function () {
												let elem = dom.id("profile-bio");
												if (elem.value.length > 255) {
													elem.value = elem.value.substring(0, 255);
												}
												dom.id("bio-characters-count").innerHTML = 255 - elem.value.length;
											},
										},
									},
									user?.value?.bio
								),
								h.div(
									{ class: "form-text text-muted small mt-1" },
									"Add a bio (",
									h.span({ id: "bio-characters-count" }, 255 - (user?.value?.bio?.length ?? 0)),
									" characters left)"
								)
							),

							// Gender
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-gender" }, "Gender"),
								h.select(
									{
										name: "profile_gender",
										class: "form-select p-3 border shadow-none rounded-3",
										id: "profile-gender",
									},
									h.call(() => {
										let options = [
											h.option({ value: "" }, "Select Gender"),
										];

										let genders = {
											male: "Male",
											female: "Female",
											none: "Prefer Not To Say",
										};

										for (let k in genders) {
											options.push(
												h.option(
													{ value: k },
													genders[k],
													either(user.value?.gender == k, {
														selected: true,
													})
												)
											);
										}

										return options;
									})
								)
							),

							// Date Of Birth
							h.div(
								{ class: "form-field" },
								h.label({ class: "form-label fw-semibold small text-secondary mb-1", for: "profile-dob" }, "Date Of Birth"),
								h.input(
									{
										type: "date",
										name: "profile_dob",
										class: "form-control p-3 border shadow-none rounded-3",
										id: "profile-dob",
									},
									h.call(() => {
										const maxDate = new Date();
										maxDate.setFullYear(maxDate.getFullYear() - 16);
										return {
											value: user.value?.dob,
											max: maxDate.toISOString().split("T")[0],
										};
									})
								)
							)
						)
					)
				),

				// Save button card
				h.div(
					{ class: "d-flex justify-content-end" },
					h.button(
						{
							type: "button",
							class: "btn btn-primary rounded-pill px-4 py-2.5 fw-bold shadow-sm d-flex align-items-center gap-2",
							onclick: this.method("updateProfile"),
						},
						h.span({}, "Update Profile"),
						h.i({ class: "bi bi-check2 fs-5" })
					)
				)
			)
		);
	}

	updateProfile() {
		let firstName = dom.id("profile-first-name");
		let lastName = dom.id("profile-last-name");
		let phone = dom.id("profile-phone");
		let displayName = dom.id("profile-display-name");
		let username = dom.id("profile-username");
		let bio = dom.id("profile-bio");
		let dob = dom.id("profile-dob");
		let gender = dom.id("profile-gender");

		if (!firstName?.value?.trim()) {
			return inform("First name cannot be empty.", "warning");
		}
		if (!lastName?.value?.trim()) {
			return inform("Last name cannot be empty.", "warning");
		}
		if (!phone?.value?.trim()) {
			return inform("Phone number cannot be empty.", "warning");
		}
		if (!displayName?.value?.trim()) {
			return inform("Display name cannot be empty.", "warning");
		}
		if (!username?.value?.trim()) {
			return inform("Username cannot be empty.", "warning");
		}
		if (this.usernameAvailable.value !== true) {
			return inform("Please choose an available username.", "warning");
		}
		if (!gender?.value) {
			return inform("Please select your gender.", "warning");
		}
		if (!dob?.value) {
			return inform("Please select your date of birth.", "warning");
		}

		let pd = {
			first_name: firstName.value?.trim(),
			last_name: lastName.value?.trim(),
			phone: phone.value?.trim(),
			display_name: displayName.value?.trim(),
			username: username.value?.trim(),
			bio: bio.value,
			is_business: gc.user?.is_business ?? 0,
			dob: dob?.value,
			gender: gender?.value,
		};

		broker.broadcast($e.user.needs.update, payload(pd));
	}

	checkUsernameAvailability(target) {
		target.value = target.value.toLowerCase().replace(/[^a-z0-9._-]/g, "");
		const username = target.value;
		this.usernameAvailable.value = null;

		if (username === gc.user?.username) {
			this.usernameAvailable.value = true;
			return;
		}

		if (!username || username.length < 3) return;
		this.usernameAvailable.value = "processing";

		if (this.debounceTimer) clearTimeout(this.debounceTimer);

		this.debounceTimer = setTimeout(async () => {
			try {
				const res = await api.get(`users/check-availability`, {
					username: username,
					exclude_id: gc.user?.id,
				});
				if (res) {
					this.usernameAvailable.value = res.data.available;
				}
			} catch (e) {
				console.error(e);
			}
		}, 500);
	}

	async confirmDeleteAccount() {
		processStart({ title: "Sending OTP" });
		let res = await api.post("/auth/send/otp");
		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
		this.showDeleteAccountModal();
	}

	async resendDeleteOtp() {
		processStart({ title: "Sending OTP" });
		let res = await api.post("/auth/send/otp");
		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
	}

	showDeleteAccountModal() {
		if (this.deleteAccountModal) {
			cleanDispose(this.deleteAccountModal);
		}

		let content = h.div(
			{ class: "modal-content border-0 shadow-lg rounded-4 overflow-hidden" },

			// Header
			h.div(
				{
					class: "modal-header border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center",
				},
				h.h5(
					{ class: "modal-title fw-bold text-danger d-flex align-items-center gap-2" },
					h.i({ class: "bi bi-exclamation-triangle-fill" }),
					"Delete Account"
				),
				h.button({
					class: "btn-close bg-light rounded-circle p-2",
					"data-bs-dismiss": "modal",
					aria_label: "Close",
				})
			),

			// Body
			h.div(
				{ class: "modal-body p-4" },
				h.p(
					{ class: "text-muted mb-4" },
					"This will schedule your account for permanent deletion in accordance with our data retention policy. Enter the One Time Password (OTP) sent to your phone and email to confirm."
				),
				h.div(
					{
						id: "delete-account-otp-input",
						class: "d-flex gap-2 justify-content-center mb-3",
					},
					h.call(() => {
						let divs = [];

						for (let i = 0; i < 5; i++) {
							divs.push(
								h.input({
									type: "number",
									class: "form-control fs-3 text-center",
									style: "width: 48px; padding: 8px 0;",
									hook: "delete-otp-input-" + i,
								})
							);
						}

						return divs;
					})
				),
				h.div(
					{ class: "text-center" },
					h.span(
						{
							class: "text-primary fw-500",
							role: "button",
							onclick: this.method("resendDeleteOtp"),
						},
						"Resend Code"
					)
				)
			),

			// Footer
			h.div(
				{ class: "modal-footer border-0 px-4 pb-4 pt-0 gap-2" },
				h.button(
					{
						class: "btn btn-light rounded-pill px-4 py-2 fw-bold flex-fill",
						"data-bs-dismiss": "modal",
					},
					"Cancel"
				),
				h.button(
					{
						id: "confirm-delete-account-btn",
						class: "btn btn-danger rounded-pill px-4 py-2 fw-bold flex-fill",
						onclick: this.method("submitAccountDeletion", ["${this}"]),
					},
					"Delete My Account"
				)
			)
		);

		this.deleteAccountModal = tool.plainModal(content, {
			id: "delete-account-modal",
			data_bs_backdrop: "static",
		});
		this.deleteAccountModal.show();

		setTimeout(() => {
			this.deleteAccountOtpInput = new VanillaOTP(dom.id("delete-account-otp-input"));
			dom.get("[hook=delete-otp-input-0]")?.focus();
		}, 150);
	}

	async submitAccountDeletion(btn) {
		let code = this.deleteAccountOtpInput?.getValue();

		if (!code || code.includes(" ")) {
			return inform("Please enter the OTP", STRINGS.WARNING);
		}

		dom.disable(btn);
		processStart({ title: "Deleting your account" });
		let res = await api.delete("user/account", { code });
		processEnd();
		dom.enable(btn);

		if (!res) return;

		this.deleteAccountModal?.hide();
		inform(res.message, STRINGS.SUCCESS);

		setTimeout(() => {
			broker.send($e.user.needs.logout);
		}, 1500);
	}

	cleanUp() {
		super.cleanUp();
		if (this.deleteAccountModal) cleanDispose(this.deleteAccountModal);
	}
}

ojs(EditProfile);
